import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import "./index.css";
import { initTheme } from "./services/themeService";
import App from "./App";
import { AppSettingsProvider } from "./contexts/AppSettingsProvider";
import registerServiceWorker from "./registerServiceWorker";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "font-awesome/css/font-awesome.css";
import { createBrowserHistory } from 'history';

initTheme();

export const history = createBrowserHistory({
  basename: process.env.PUBLIC_URL
});

ReactDOM.render(
  <BrowserRouter basename="/client">
    <AppSettingsProvider>
      <App />
    </AppSettingsProvider>
  </BrowserRouter>,
  document.getElementById("root")
);
registerServiceWorker();
